/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiErrorResponse {
  Error: Error
}

export interface Cell {
  /** @format int32 */
  RowNumber: number
  ColumnName: ColumnName
  Value?: string | null
  IsHeader: boolean
}

/** Model for a cell of a sheet */
export interface CellModel {
  /**
   * The row number of the cell
   * @format int32
   */
  RowNumber: number
  /** The name of the column to which the cell belongs */
  ColumnName: string
  /** The value contained within the cell */
  Value: string
  /** Indicates whether the cell is a header cell or not */
  IsHeader: boolean
}

export interface ColumnName {
  /** @format int32 */
  Value: number
}

export interface ContentMetadataModel {
  /** String in JSON format. */
  Metadata: string
}

export interface ContentMetadataRenameModel {
  /**
   * A new name of a tab.
   * @minLength 1
   * @maxLength 100
   */
  Name: string
}

export interface ContentMetadataRowAmountModel {
  /**
   * A total number of rows in a tab
   * @format int32
   */
  RowAmount: number
}

export interface ContentMetadataRowsDeleteModel {
  /**
   * A list of unique id of metadata rows
   * @minItems 1
   */
  RowIds: number[]
}

export interface ContentMetadataTabModel {
  /**
   * The unique id of the tab
   * @format int32
   */
  TabId: number
  /**
   * The name of the tab
   * @minLength 1
   * @maxLength 100
   */
  TabName: string
  /**
   * Id of a section that may be attached to a tab
   * @format int32
   */
  SectionId?: number | null
  /**
   * Date of a tab creation
   * @format date-time
   */
  CreatedOn: string
}

export interface ContentMetadataTabUploadModel {
  /**
   * String in JSON format. Contains an array of metadata values to upload. Must match a schema
   * @minLength 1
   */
  Metadata: string
}

export interface ContentMetadataUpdateModel {
  /**
   * String in JSON format. Contains an array of metadata values to upload. Must match a schema
   * @minLength 1
   */
  Metadata: string
}

export interface ContentMetadataUploadModel {
  /**
   * String in JSON format. Contains metadata to upload. Must match a schema
   * @minLength 1
   * @maxLength 2000000000
   */
  Metadata: string
}

/** Represents a model for creating intervals. */
export interface CreateIntervalModel {
  /** The collection of intervals to create, with each interval represented by an IntervalModel */
  Intervals: IntervalModel[]
}

/** Represents a model for creating a new sheet. */
export interface CreateSheetModel {
  /**
   *
   *
   * 1 = Content
   *
   * 2 = Page
   *
   * 3 = User
   */
  Type: SheetType
  /**
   * The ID of the entity associated with the sheet
   * @format int32
   */
  EntityId: number
  /** The name of the sheet */
  Name: string
  /** The collection of cell models to initialize the sheet with (optional) */
  Cells?: CellModel[] | null
  /** The collection of interval models to initialize the sheet with (optional) */
  Intervals?: IntervalModel[] | null
}

export interface CreatedContentMetadataModel {
  /**
   * Unique id of the ContentMetadata tab within the system..
   * @format int32
   */
  TabId: number
  /** A list of unique id of the ContentMetadata rows within the system. */
  RowIds: number[]
}

export interface Error {
  /** @format int32 */
  Code: number
  /** @minLength 1 */
  Message: string
  Details?: string | null
}

/** Represents a model for exporting sheets via email. */
export interface ExportSheetsModel {
  /** The Ids of the sheets to be exported */
  SheetIds: number[]
  /** The list of recipient email addresses */
  Emails: string[]
  /** The header for the email message */
  EmailHeader: string
}

export interface History {
  Name: string
  /**
   *
   *
   * 0 = Active
   *
   * 1 = Locked
   *
   * 2 = Deleted
   */
  Status: SheetStatus
  /** @format int32 */
  StructureId?: number | null
  /** @format uuid */
  UpdatedByUserId?: string | null
  /** @format date-time */
  UpdatedOn?: string | null
}

export type IActionResult = object

/** Represents a model for a single sheet to import into spreadsheets. */
export interface ImportSheetModel {
  /** The name to be used for the imported sheet. */
  Name: string
  /**
   * The index of the sheet within the source file. Starts from 1
   * @format int32
   */
  Index: number
}

/** Represents a model for initiating an import to spreadsheets. */
export interface InitiateImportRequest {
  /** A collection of sheets to import, each represented by an Tabeeb.SpreadsheetMicroservice.Contracts.Requests.InitiateImportRequest.ImportSheetModel. */
  Sheets: ImportSheetModel[]
  /**
   * The ID of the content associated with the sheets being imported.
   * @format int32
   */
  ContentId: number
  /** The URL from which to import the sheets. */
  FileUrl: string
}

/** Represents a model for initiating table recognition. */
export interface InitiateTableRecognitionModel {
  /** The URL of the file to perform table recognition on */
  FileUrl: string
  /**
   * The Id of the content associated with the sheet
   * @format int32
   */
  ContentId: number
}

export interface Interval {
  /** @format int32 */
  FromRow: number
  FromColumn: ColumnName
  /** @format int32 */
  ToRow: number
  ToColumn: ColumnName
  /**
   *
   *
   * 0 = Span
   *
   * 1 = TextTransform
   *
   * 2 = BorderTransform
   *
   * 3 = OuterBorderTransform
   *
   * 4 = TextColor
   *
   * 5 = FillColor
   *
   * 6 = Align
   *
   * 7 = Dropdown
   *
   * 8 = DataType
   *
   * 9 = Locked
   *
   * 10 = Hidden
   */
  Type: IntervalType
  Value?: string | null
}

/** Represents an interval model for a range of cells. */
export interface IntervalModel {
  /**
   * The starting row index of the interval
   * @format int32
   */
  FromRow: number
  /** The starting column name of the interval */
  FromColumn: string
  /**
   * The ending row index of the interval
   * @format int32
   */
  ToRow: number
  /** The ending column name of the interval */
  ToColumn: string
  /**
   *
   *
   * 0 = Span
   *
   * 1 = TextTransform
   *
   * 2 = BorderTransform
   *
   * 3 = OuterBorderTransform
   *
   * 4 = TextColor
   *
   * 5 = FillColor
   *
   * 6 = Align
   *
   * 7 = Dropdown
   *
   * 8 = DataType
   *
   * 9 = Locked
   *
   * 10 = Hidden
   */
  Type: IntervalType
  /** The value associated with the interval */
  Value?: string | null
}

/**
 *
 *
 * 0 = Span
 *
 * 1 = TextTransform
 *
 * 2 = BorderTransform
 *
 * 3 = OuterBorderTransform
 *
 * 4 = TextColor
 *
 * 5 = FillColor
 *
 * 6 = Align
 *
 * 7 = Dropdown
 *
 * 8 = DataType
 *
 * 9 = Locked
 *
 * 10 = Hidden
 * @format int32
 */
export enum IntervalType {
  Span = 0,
  TextTransform = 1,
  BorderTransform = 2,
  OuterBorderTransform = 3,
  TextColor = 4,
  FillColor = 5,
  Align = 6,
  Dropdown = 7,
  DataType = 8,
  Locked = 9,
  Hidden = 10,
}

/** Represents a model for indicating whether a sheet name is unique. */
export interface IsSheetNameUniqueModel {
  /** Indicating whether the sheet name is unique. */
  IsUnique: boolean
}

export interface Sheet {
  /** @format int32 */
  Id: number
  /** @format int32 */
  TenantId: number
  /**
   *
   *
   * 0 = Active
   *
   * 1 = Locked
   *
   * 2 = Deleted
   */
  Status: SheetStatus
  /**
   *
   *
   * 1 = Content
   *
   * 2 = Page
   *
   * 3 = User
   */
  Type: SheetType
  /** @format int32 */
  EntityId: number
  Name: string
  /** @format uuid */
  CreatedByUserId: string
  /** @format date-time */
  CreatedOn: string
  /** @format uuid */
  UpdatedByUserId: string
  /** @format date-time */
  UpdatedOn: string
}

/**
 *
 *
 * 0 = Active
 *
 * 1 = Locked
 *
 * 2 = Deleted
 * @format int32
 */
export enum SheetStatus {
  Active = 0,
  Locked = 1,
  Deleted = 2,
}

/**
 *
 *
 * 1 = Content
 *
 * 2 = Page
 *
 * 3 = User
 * @format int32
 */
export enum SheetType {
  Content = 1,
  Page = 2,
  User = 3,
}

/** Represents a model for updating or inserting cells. */
export interface UpdateCellsModel {
  /** The collection of cell models representing the cells to update or insert */
  Cells: CellModel[]
}

/** Represents a model for updating sheet properties. */
export interface UpdateSheetModel {
  /**
   *
   *
   * 0 = Active
   *
   * 1 = Locked
   *
   * 2 = Deleted
   */
  Status?: SheetStatus
  /** The new name of the sheet (optional) */
  Name?: string | null
  /** Indicates whether the structure of the sheet should be enforced (optional) */
  IsStructureEnforced?: boolean | null
  /**
   * The ID of the new structure associated with the sheet (optional)
   * @format int32
   */
  StructureId?: number | null
}

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://api-dev.collaborate.center/staging/',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Spreadsheets api
 * @baseUrl https://api-dev.collaborate.center/staging/
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  contentMetadataOld = {
    /**
     * No description
     *
     * @tags Content metadata (old)
     * @name GetMetadataTabsAsync
     * @summary Returns a list of metadata tabs uploaded to the content.
     * @request GET:/spreadsheet-service/api/contentMetadata/{contentId}/tabs
     * @secure
     */
    getMetadataTabsAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<ContentMetadataTabModel[], ApiErrorResponse>({
        path: `/spreadsheet-service/api/contentMetadata/${contentId}/tabs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description The metadata is stringified JSON object containing properties "columns" and "data". The "columns" property is an array of strings, that are representing names of columns. The "data" property is an array of objects with properties "rowId" and "values". The "rowId" is an integer unique id of a row. The "values" property is an object containing key-value pairs like: "column name":"value"
     *
     * @tags Content metadata (old)
     * @name GetMetadataAsync
     * @summary Returns metadata of the specified tab.
     * @request GET:/spreadsheet-service/api/contentMetadata/{contentId}/{tabId}
     * @secure
     */
    getMetadataAsync: (
      contentId: number,
      tabId: number,
      query?: {
        /**
         * The integer offset of qualifying rows that are ignored before the first returned row
         * @format int32
         * @default 0
         */
        skip?: number
        /**
         * The max amount of the rows to be returned
         * @format int32
         * @default 100
         */
        take?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ContentMetadataModel, ApiErrorResponse>({
        path: `/spreadsheet-service/api/contentMetadata/${contentId}/${tabId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content metadata (old)
     * @name GetMetadataRowAmountAsync
     * @summary Returns a row amount of the specified tab.
     * @request GET:/spreadsheet-service/api/contentMetadata/{contentId}/{tabId}/rowAmount
     * @secure
     */
    getMetadataRowAmountAsync: (contentId: number, tabId: number, params: RequestParams = {}) =>
      this.http.request<ContentMetadataRowAmountModel, ApiErrorResponse>({
        path: `/spreadsheet-service/api/contentMetadata/${contentId}/${tabId}/rowAmount`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Use the following schema for an object to upload metadata: { "type": "object", "properties": { "tabName": { "type": "string", "required": true, "minLength": 1, "maxLength": 100, "pattern": "\\S.*$" }, "columns": { "type": "array", "required": true, "items": { "type": "string", "minLength": 1, "maxLength": 100, "pattern": "^\\S.{1,100}$" }, "minItems": 1, "uniqueItems": true }, "data": { "type": "array", "items": { "type": "object", "patternProperties": { "^.{1,100}$": { "type": [ "string", "number", "boolean" ] } }, "additionalProperties": false }, "required": true } }, "additionalProperties": false } Root contains 3 required properties: tabName, columns and data. The "tabName" property is a name of the tab in string type. The "columns" property is a string array which represents the structure of a tab. Each string in the array is a column in a tab view. You can specify up to n columns for each tab. The "data" property is an array of objects. Each object in the array contains key-value pairs that are values, assigned to column names. The value could be a string, boolean or int type. It is allowed not to assign columns with values. So that values in these columns would be empty. If the value has been assigned to a column, that not exists in the tab, it will not be displayed in tab view. Sample object: { "tabName":"tab1", "columns": [ "col1", "col2", "col3" ], "data": [ { "col1": "value1", "col2": "value2" }, { "col1": "sample", "col3": "sample3" } ] } Once the object is ready, stringify it to use in a request. Sample request uploading a tab: POST api/ContentMetadata/123456 { "Metadata": "{ \"tabName\":\"tab1\", \"columns\": [ \"col1\", \"col2\", \"col3\" ], \"data\": [ { \"col1\": \"value1\", \"col2\": \"value2\" }, { \"col1\": \"sample\", \"col3\": \"sample3\" } ] }" }
     *
     * @tags Content metadata (old)
     * @name UploadMetadataAsync
     * @summary Adds a content metadata tab
     * @request POST:/spreadsheet-service/api/contentMetadata/{contentId}
     * @secure
     */
    uploadMetadataAsync: (contentId: number, data: ContentMetadataUploadModel, params: RequestParams = {}) =>
      this.http.request<CreatedContentMetadataModel, ApiErrorResponse | void>({
        path: `/spreadsheet-service/api/contentMetadata/${contentId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Use the following schema to upload data to the content metadata tab: { "type":"array", "required":true, "minItems":1, "items":{ "type":"object", "patternProperties":{ "^.{1,100}$":{ "type":[ "string", "number", "boolean" ] } }, "additionalProperties":false } } The schema describes the structure of the array with metadata. Each object in the array contains key-value pairs that are values, assigned to column names. The value could be a string, boolean or int type. It is allowed not to assign columns with values. So that values in these columns would be empty. If the value has been assigned to a column, that not exists in the tab, it will not be displayed in tab view. Sample array: [ {"col1": "data", "col2": 123}, {"col1": "some_value", "col3": 123} ] Once the array is ready, stringify it to use in a request. Sample request uploading 2 rows: POST api/ContentMetadata/123456/rows { "Metadata": "[{\"col1\": \"data\", \"col2\": 123}, {\"col1\": \"some_value\", \"col3\": 123}]" }
     *
     * @tags Content metadata (old)
     * @name UploadTabMetadataAsync
     * @summary Adds data to the existing content metadata tab
     * @request POST:/spreadsheet-service/api/contentMetadata/{tabId}/rows
     * @secure
     */
    uploadTabMetadataAsync: (tabId: number, data: ContentMetadataTabUploadModel, params: RequestParams = {}) =>
      this.http.request<number[], ApiErrorResponse | void>({
        path: `/spreadsheet-service/api/contentMetadata/${tabId}/rows`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Use the following schema to update the content metadata: { "type":"array", "required":true, "minItems":1, "items":{ "type":"object", "properties": { "rowId": { "type": "number", "required": true }, "newValues": { "type": "object", "required": true, "patternProperties": { "^.{1,100}$": { "type": [ "string", "number", "boolean" ] } } } }, "additionalProperties":false } } The schema describes the structure of the array with metadata. Each object in the array contains following properties: "rowId" and "newValues". The "rowId" is an integer unique id of a row. The "newValues" property is an object containing key-value pairs like: "column name":"value". Old values will be replaced by new values from this pair. Sample object: [ { "rowId": 150, "newValues": { "col1": "newvalue1", "col2": "newvalue2" } }, { "rowId": 15, "newValues": { "col3": "newvalue3" } } ] Once the object is ready, stringify it to use in a request. Sample request updating a tab: PUT api/ContentMetadata/123456 { "Metadata": "[ { \"rowId\": 150, \"newValues\": { \"col1\": \"newvalue1\", \"col2\": \"newvalue2\" } }, { \"rowId\": 15, \"newValues\": { \"col3\": \"newvalue3\" } } ]" }
     *
     * @tags Content metadata (old)
     * @name UpdateMetadataAsync
     * @summary Updates data of the existing content metadata tab
     * @request PUT:/spreadsheet-service/api/contentMetadata/{tabId}
     * @secure
     */
    updateMetadataAsync: (tabId: number, data: ContentMetadataUpdateModel, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/spreadsheet-service/api/contentMetadata/${tabId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content metadata (old)
     * @name DeleteMetadataTabAsync
     * @summary Deletes the existing content metadata tab
     * @request DELETE:/spreadsheet-service/api/contentMetadata/{tabId}
     * @secure
     */
    deleteMetadataTabAsync: (tabId: number, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse>({
        path: `/spreadsheet-service/api/contentMetadata/${tabId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content metadata (old)
     * @name RenameAsync
     * @summary Renames content metadata tab.
     * @request PUT:/spreadsheet-service/api/contentMetadata/{tabId}/rename
     * @secure
     */
    renameAsync: (tabId: number, data: ContentMetadataRenameModel, params: RequestParams = {}) =>
      this.http.request<ContentMetadataTabModel, ApiErrorResponse | void>({
        path: `/spreadsheet-service/api/contentMetadata/${tabId}/rename`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Content metadata (old)
     * @name DeleteMetadataRowsAsync
     * @summary Deletes rows in the existing content metadata tab.
     * @request POST:/spreadsheet-service/api/contentMetadata/{tabId}/deleteRows
     * @secure
     */
    deleteMetadataRowsAsync: (tabId: number, data: ContentMetadataRowsDeleteModel, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/spreadsheet-service/api/contentMetadata/${tabId}/deleteRows`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  spreadsheetServiceContentMetadataNew = {
    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name GetSheetsAsync
     * @summary Returns a list of sheets.
     * @request GET:/spreadsheet-service/api/Spreadsheet
     * @secure
     */
    getSheetsAsync: (
      query?: {
        /**
         * The type of sheet.
         *
         * 1 = Content
         *
         * 2 = Page
         *
         * 3 = User
         */
        Type?: SheetType
        /**
         * The entity ID associated with the sheet.
         * @format int32
         */
        EntityId?: number
        /** The name of the sheet. */
        Name?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<Sheet[], ApiErrorResponse>({
        path: `/spreadsheet-service/api/Spreadsheet`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name CreateSheetAsync
     * @summary Creates a sheet
     * @request POST:/spreadsheet-service/api/Spreadsheet
     * @secure
     */
    createSheetAsync: (data: CreateSheetModel, params: RequestParams = {}) =>
      this.http.request<Sheet, ApiErrorResponse | void>({
        path: `/spreadsheet-service/api/Spreadsheet`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name GetIsSheetNameUniqueAsync
     * @summary Returns whether a sheet name is unique.
     * @request GET:/spreadsheet-service/api/Spreadsheet/isUnique
     * @secure
     */
    getIsSheetNameUniqueAsync: (
      query?: {
        /**
         * The type of sheet.
         *
         * 1 = Content
         *
         * 2 = Page
         *
         * 3 = User
         */
        Type?: SheetType
        /**
         * The entity ID associated with the sheet.
         * @format int32
         */
        EntityId?: number
        /** The name of the sheet. */
        Name?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<IsSheetNameUniqueModel, ApiErrorResponse>({
        path: `/spreadsheet-service/api/Spreadsheet/isUnique`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name GetCellsAsync
     * @summary Retrieves cells for a specified sheet.
     * @request GET:/spreadsheet-service/api/Spreadsheet/{sheetId}
     * @secure
     */
    getCellsAsync: (
      sheetId: number,
      query?: {
        /**
         * Specifies the starting row for the query
         * @format int32
         */
        FromRow?: number
        /**
         * Specifies the ending row for the query
         * @format int32
         */
        ToRow?: number
        /**
         * Specifies a specific date and time for reference
         * @format date-time
         */
        ForDateTime?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<Cell[], ApiErrorResponse>({
        path: `/spreadsheet-service/api/Spreadsheet/${sheetId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name UpdateSheetAsync
     * @summary Updates information about a specific sheet.
     * @request PUT:/spreadsheet-service/api/Spreadsheet/{sheetId}
     * @secure
     */
    updateSheetAsync: (sheetId: number, data: UpdateSheetModel, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/spreadsheet-service/api/Spreadsheet/${sheetId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name GetIntervalsAsync
     * @summary Retrieves intervals for a specified sheet.
     * @request GET:/spreadsheet-service/api/Spreadsheet/{sheetId}/intervals
     * @secure
     */
    getIntervalsAsync: (
      sheetId: number,
      query?: {
        /**
         * The date and time for which intervals are being retrieved
         * @format date-time
         */
        forDateTime?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<Interval[], ApiErrorResponse>({
        path: `/spreadsheet-service/api/Spreadsheet/${sheetId}/intervals`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name CreateIntervalsAsync
     * @summary Creates intervals on a specific sheet.
     * @request POST:/spreadsheet-service/api/Spreadsheet/{sheetId}/intervals
     * @secure
     */
    createIntervalsAsync: (sheetId: number, data: CreateIntervalModel, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/spreadsheet-service/api/Spreadsheet/${sheetId}/intervals`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name GetHistoryAsync
     * @summary Retrieves historical data for a specified sheet within a specified date and time range.
     * @request GET:/spreadsheet-service/api/Spreadsheet/{sheetId}/history
     * @secure
     */
    getHistoryAsync: (
      sheetId: number,
      query?: {
        /**
         * The starting date and time of the history range
         * @format date-time
         */
        FromDateTime?: string
        /**
         * The ending date and time of the history range
         * @format date-time
         */
        ToDateTime?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<History[], ApiErrorResponse>({
        path: `/spreadsheet-service/api/Spreadsheet/${sheetId}/history`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name InsertRowWithShiftAsync
     * @summary Inserts a row and shifts down rows below
     * @request POST:/spreadsheet-service/api/Spreadsheet/{sheetId}/rows/{rowNumber}
     * @secure
     */
    insertRowWithShiftAsync: (sheetId: number, rowNumber: number, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse>({
        path: `/spreadsheet-service/api/Spreadsheet/${sheetId}/rows/${rowNumber}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name DeleteRowWithShiftAsync
     * @summary Deletes a row from a sheet and shifts the rows below it upwards.
     * @request DELETE:/spreadsheet-service/api/Spreadsheet/{sheetId}/rows/{rowNumber}
     * @secure
     */
    deleteRowWithShiftAsync: (sheetId: number, rowNumber: number, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse>({
        path: `/spreadsheet-service/api/Spreadsheet/${sheetId}/rows/${rowNumber}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name InsertColumnWithShiftAsync
     * @summary Inserts a column and shifts right rest columns
     * @request POST:/spreadsheet-service/api/Spreadsheet/{sheetId}/columns/{columnName}
     * @secure
     */
    insertColumnWithShiftAsync: (sheetId: number, columnName: string, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse>({
        path: `/spreadsheet-service/api/Spreadsheet/${sheetId}/columns/${columnName}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name UpsertCellsAsync
     * @summary Updates or inserts cells in a specific sheet.
     * @request PUT:/spreadsheet-service/api/Spreadsheet/{sheetId}/cells
     * @secure
     */
    upsertCellsAsync: (sheetId: number, data: UpdateCellsModel, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/spreadsheet-service/api/Spreadsheet/${sheetId}/cells`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name DeleteColumnWithShiftAsync
     * @summary Deletes a column from a sheet and shifts the remaining columns to the left.
     * @request DELETE:/spreadsheet-service/api/Spreadsheet/{sheetId}/columns/{name}
     * @secure
     */
    deleteColumnWithShiftAsync: (sheetId: number, name: string, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse>({
        path: `/spreadsheet-service/api/Spreadsheet/${sheetId}/columns/${name}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name SendForRecognitionAsync
     * @summary Initiates table recognition.
     * @request POST:/spreadsheet-service/api/Spreadsheet/recognize
     * @secure
     */
    sendForRecognitionAsync: (data: InitiateTableRecognitionModel, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/spreadsheet-service/api/Spreadsheet/recognize`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name SendForExportAsync
     * @summary Initiates the export of sheets via email using the provided model.
     * @request POST:/spreadsheet-service/api/Spreadsheet/export
     * @secure
     */
    sendForExportAsync: (data: ExportSheetsModel, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/spreadsheet-service/api/Spreadsheet/export`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spreadsheet service (Content Metadata new)
     * @name SendForImportAsync
     * @summary Initiates the import of xlsx files.
     * @request POST:/spreadsheet-service/api/Spreadsheet/import
     * @secure
     */
    sendForImportAsync: (data: InitiateImportRequest, params: RequestParams = {}) =>
      this.http.request<IActionResult, ApiErrorResponse | void>({
        path: `/spreadsheet-service/api/Spreadsheet/import`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
}
